import * as React from 'react';
import { Aeroexpress as AeroexpressRoot } from '../../../../../../CheckoutAdditionalService/components';
import { Subway, Time } from '../../../../../../Icons';
const AggregatedAeroexpress = ({ service, segmentId }) => {
    const aeroexpress = {
        trips: service.services,
        selectedTrips: service.selectedServices.map(selected => selected.service)
    };
    return (React.createElement(AeroexpressRoot, { aggregationMode: true, aeroexpress: aeroexpress, isSelected: !!aeroexpress.selectedTrips.length, icons: [Subway, Time] }));
};
export default AggregatedAeroexpress;
